export default {
      id: "error-mess-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#error-mess",
      toString: function () {
        return this.url;
      }
    }